/*import AES256 from '@infotrack/utilitarios/aes256';
import { IEstadoPersistido } from 'Infotrack@Principal/contextoGeneral/interfaces';
import { llaveGlobal } from 'Infotrack@Transversales/constantes/crendeciales';
import XLSX from 'xlsx';

export const obtenerConfiguracionApp = (): IEstadoPersistido => {
    const aes256 = new AES256();
    const estado = sessionStorage.getItem('estadoApp');
    if (estado) {
        return JSON.parse(aes256.descifrar(estado, llaveGlobal));
    } else {
        return {
            aplicaciones: [],
            idAplicacionSeleccionada: undefined,
            lenguajeActivo: undefined,
            temaActivo: undefined,
            token: undefined,
            subMenuSeleccionado: undefined,
            rutaActiva: 'app',
            usuario: {
                NombreCompleto: '',
                NombreUsuario: '',
                CorreoElectronico: '',
                IdUsuario: '',
                Foto: '',
                IdEmpresa: '',
                Token: '',
            },
        };
    }
};

export const modificarTituloIconoAplicacion = (titulo: string) => {
    window.document.title = titulo;
    const favIconAnterior = document.getElementById('favicon') as HTMLLinkElement;
    const nuevoFavIcon = document.createElement('link');
    nuevoFavIcon.id = 'favicon';
    nuevoFavIcon.rel = 'shortcut icon';
    nuevoFavIcon.href = `${titulo.replace(/ /g, '').toLowerCase()}.ico`;
    if (favIconAnterior) {
        document.head.removeChild(favIconAnterior);
    }
    document.head.appendChild(nuevoFavIcon);
};

export const comprimirImagen = (base64: string): Promise<string> => {
    const canvas = document.createElement('canvas');
    const img = document.createElement('img');
    img.src = base64;

    return new Promise((resolve) => {
        img.onload = () => {
            if (img.width > img.height) {
                const relWidth = img.width / 16;
                const relHeigth = img.height / 9;
                if (relWidth === relHeigth) {
                    canvas.width = 768;
                    canvas.height = 432;
                } else {
                    canvas.width = 800;
                    canvas.height = 600;
                }
            } else {
                const relHeigth = img.height / 16;
                const relWidth = img.width / 9;
                if (relWidth === relHeigth) {
                    canvas.width = 432;
                    canvas.height = 768;
                } else {
                    canvas.width = 600;
                    canvas.height = 800;
                }
            }
            const contexto = canvas.getContext('2d');
            contexto!.drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL('image/jpeg', 0.9));
        };
    });
};

export function exportarExcel<T>(datos: T[][], nombreArchivo: string) {
    const datosFormateados = datos.map((fila) =>
        fila.map((celda) => (typeof celda === 'number' ? celda.toString() : celda))
    );
    const hojaCalculo = XLSX.utils.aoa_to_sheet(datosFormateados);
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hojaCalculo, nombreArchivo);
    const numeroColumnas = XLSX.utils.decode_range(hojaCalculo['!ref']!).e.c;
    hojaCalculo['!cols'] = [];
    for (let i = 0; i <= numeroColumnas; i++) hojaCalculo['!cols']!.push({ wpx: 120 });
    XLSX.writeFile(libro, `${nombreArchivo}.xlsx`);

}*/

import AES256 from '@infotrack/utilitarios/aes256';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import { llaveGlobal } from 'Infotrack@Transversales/constantes/crendeciales';
import { useLocation } from 'react-router';
import XLSX from 'xlsx';

export const obtenerConfiguracionApp = (): IEstadoGlobal => {
    const aes256 = new AES256();
    const estado = sessionStorage.getItem('estadoApp');
    if (estado) {
        return JSON.parse(aes256.descifrar(estado, llaveGlobal));
    } else {
        return {
            estadoAutenticacion: {
                agenciaActual: null,
                menus: [],
                permisos: [],
                usuarioAplicacionAgenciaActual: null,
                usuarioInformacion: null,
            },
            estadoConfiguracion: {
                lenguajeActivo: 'es',
                lenguajes: ['es', 'en'],
                menuSeleccionado: 0,
                rutaActiva: 'app',
                subMenuSeleccionado: '',
                temaActivo: 'SmartStock',
            },
        };
    }
};
export const modificarTituloIconoAplicacion = (titulo: string) => {
    window.document.title = titulo;
    const favIconAnterior = document.getElementById('favicon') as HTMLLinkElement;
    const nuevoFavIcon = document.createElement('link');
    nuevoFavIcon.id = 'favicon';
    nuevoFavIcon.rel = 'shortcut icon';
    nuevoFavIcon.href = `${titulo.replace(/ /g, '').toLowerCase()}.ico`;
    if (favIconAnterior) {
        document.head.removeChild(favIconAnterior);
    }
    document.head.appendChild(nuevoFavIcon);
};

export function exportarExcel<T>(datos: T[][], nombreArchivo: string) {
    const datosFormateados = datos.map((fila) =>
        fila.map((celda) => (typeof celda === 'number' ? celda.toString() : celda))
    );
    const hojaCalculo = XLSX.utils.aoa_to_sheet(datosFormateados);
    const libro = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(libro, hojaCalculo, nombreArchivo);
    const numeroColumnas = XLSX.utils.decode_range(hojaCalculo['!ref']!).e.c;
    hojaCalculo['!cols'] = [];
    for (let i = 0; i <= numeroColumnas; i++) hojaCalculo['!cols']!.push({ wpx: 120 });
    XLSX.writeFile(libro, `${nombreArchivo}.xlsx`);
}

export function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export const comprimirImagen = (base64: string): Promise<string> => {
    const canvas = document.createElement('canvas');
    const img = document.createElement('img');
    img.src = base64;

    return new Promise((resolve) => {
        img.onload = () => {
            if (img.width > img.height) {
                const relWidth = img.width / 16;
                const relHeigth = img.height / 9;
                if (relWidth === relHeigth) {
                    canvas.width = 768;
                    canvas.height = 432;
                } else {
                    canvas.width = 800;
                    canvas.height = 600;
                }
            } else {
                const relHeigth = img.height / 16;
                const relWidth = img.width / 9;
                if (relWidth === relHeigth) {
                    canvas.width = 432;
                    canvas.height = 768;
                } else {
                    canvas.width = 600;
                    canvas.height = 800;
                }
            }
            const contexto = canvas.getContext('2d');
            contexto!.drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL('image/jpeg', 0.9));
        };
    });
};

export const comprimirImagenDocumentoEvidencia = (base64: string, esPdf: boolean): Promise<string> => {
    const canvas = document.createElement('canvas');
    const img = document.createElement('img');
    let imagenPDF = '../../../../../public/imagenPDF.png';
    img.src = base64;
    return new Promise((resolve) => {
        img.onload = () => {
            if (img.width > img.height) {
                const relWidth = img.width / 16;
                const relHeigth = img.height / 9;
                if (relWidth === relHeigth) {
                    canvas.width = 768;
                    canvas.height = 432;
                } else {
                    canvas.width = 800;
                    canvas.height = 600;
                }
            } else {
                const relHeigth = img.height / 16;
                const relWidth = img.width / 9;
                if (relWidth === relHeigth) {
                    canvas.width = 432;
                    canvas.height = 768;
                } else {
                    canvas.width = 600;
                    canvas.height = 800;
                }
            }
            const contexto = canvas.getContext('2d');
            contexto!.drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL('image/jpeg', 0.9));
        };
    });
};
